export const paramLabels = {
  name: 'site',
  county: 'county',
  city: 'city',
  state: 'state',
  zip_code: 'zip',
  region: 'region',
  status: 'site status',
  priority: 'priority',
  site_type: 'site type',
  tag_name: 'tag',
  h2a: 'h2a',
  icon: 'icon',
  arrival: 'arriving on/before',
  departure: 'departing on/after',
  contact_name: 'contact name',
  contact_company: 'company',
  contact_type: 'contact type',
  visited: 'visit status',
  season_name: 'season',
  created_from: 'created on/after',
  created_to: 'created on/before',
};

export const excludedKeys = [
  'organization_id',
  'limit',
  'offset',
  'page',
  'sort',
  'ordering',
  'sortBy',
  'mode',
];
